import { render } from "./DiagnosticCard.vue?vue&type=template&id=24419104"
import script from "./DiagnosticCard.vue?vue&type=script&lang=js"
export * from "./DiagnosticCard.vue?vue&type=script&lang=js"

import "./DiagnosticCard.vue?vue&type=style&index=0&id=24419104&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__